import { Form } from 'antd';
import React from 'react';

import Dropdown from '@/atoms/dropdown';
import { FilterComponentInput } from '@core/offices/types';

const component = (props: FilterComponentInput) => {
  return (
    <Form.Item initialValue={props.value} label={props.filter.label}>
      <Dropdown
        key={props.filter.label}
        className="w-40 rounded-full h-9 text-xs"
        placeholder={props.filter.placeholder}
        options={props.filter.options}
        mode={props.filter.isMultiSelect === '1' ? 'multiple' : null}
        maxTagCount={props.filter.isMultiSelect === '1' ? 'responsive' : null}
        name={props.filter.fieldName}
        value={props.value}
        onChange={(e) => props.handleChange(e)}
      />
    </Form.Item>
  );
};
export default component;
